import { Box } from '@mui/material';
import Lottie from 'lottie-react';
import React from 'react';

import blueWave from '@/assets/animations/blue-wave.json';
import purpleWave from '@/assets/animations/purple-wave.json';
import { EquinetPremium, EquinetTeams } from '@/assets/svg';
import { useSubscriptionContext } from '@/context/SubscriptionContext';
import { COLOR, ENTITY_COLOR } from '@/theme/colors';

const SubscriptionHeader: React.FC = () => {
    const { currentOrganisationSubscriptionPlan } = useSubscriptionContext();

    const isTeamSubscription =
        currentOrganisationSubscriptionPlan?.seats &&
        currentOrganisationSubscriptionPlan?.seats > 1;

    return (
        <Box className="relative">
            <Lottie
                className="absolute bottom-0 left-0 right-0 opacity-30"
                animationData={isTeamSubscription ? purpleWave : blueWave}
            />

            <Box
                sx={{
                    display: 'flex',
                    gap: '8px',
                    maxWidth: '1300px',
                    mx: 'auto',
                    width: '100%',
                    py: '30px',
                    px: '24px',
                }}
            >
                {isTeamSubscription ? (
                    <EquinetTeams color={ENTITY_COLOR.teams} width={270} />
                ) : (
                    <EquinetPremium color={COLOR.deepCerulean} width={270} />
                )}
            </Box>
        </Box>
    );
};

export default SubscriptionHeader;
